import { TreatmentTemplate } from './treatment-template';

export const DEFAULT_TREATMENT_TEMPLATES = [
  { name: 'Existing Patient Check Up & Clean', isPublic: true },
  { name: 'Consultation', isPublic: true },
  { name: 'Emergency', isPublic: true },
  { name: 'New Patient Check Up & Clean', isPublic: true },
].map((treatmentTemplate) => TreatmentTemplate.init(treatmentTemplate));
